// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Subtitle_subtitle__5od_E","metadataText":"Subtitle_metadataText__niHWe"};